function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.02 15.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-left-double") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Giving-History"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Giving-History---Date-Dropdown"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Give-Again-Arrow-Copy",
    d: "M7.16,8.23l7.18,7.18a.6.6,0,0,0,.44.18.6.6,0,0,0,.43-.18l1.61-1.61a.58.58,0,0,0,.18-.43.62.62,0,0,0-.18-.44L11.68,7.8l5.14-5.14A.6.6,0,0,0,17,2.22a.6.6,0,0,0-.18-.43L15.21.18A.6.6,0,0,0,14.78,0a.6.6,0,0,0-.44.18L7.16,7.36A.6.6,0,0,0,7,7.8.6.6,0,0,0,7.16,8.23Z",
    transform: "translate(0.02)",
    style: {
      fill: "#2774ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Give-Again-Arrow-Copy-2",
    d: "M.16,8.23l7.18,7.18a.6.6,0,0,0,.44.18.6.6,0,0,0,.43-.18L9.82,13.8a.58.58,0,0,0,.18-.43.62.62,0,0,0-.18-.44L4.68,7.8,9.82,2.66A.6.6,0,0,0,10,2.22a.6.6,0,0,0-.18-.43L8.21.18A.6.6,0,0,0,7.78,0a.6.6,0,0,0-.44.18L.16,7.36A.6.6,0,0,0,0,7.8.6.6,0,0,0,.16,8.23Z",
    transform: "translate(0.02)",
    style: {
      fill: "#2774ae"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftDouble);
export default __webpack_public_path__ + "static/media/arrow-left-double.0e8e3bd9fb54d1c4972ccb69f2bc03bb.svg";
export { ForwardRef as ReactComponent };